import React from 'react';
import axios from 'axios';
import { renderToStaticMarkup } from 'react-dom/server';

import { cardImages } from '../itcgCardImages';
import { ITCGDeckBuilder } from './deckBuilder';
import { CardStyle, LoadStyle, ParagraphStyle } from './overall.css';

import { Deck } from '../game';

interface DeckProp {
  server: string;
}

export interface DeckMetaData {
  id: string;
  name: string;
  deck_list: Deck;
  modify: boolean;
}

export interface State {
  initialLoad: boolean;
  decks: DeckMetaData[];
  build: boolean;
  buildDeck?: string;
  width: number;
}

const baseStyle: React.CSSProperties = {
  margin: '1%',
  display: 'flex',
  flexDirection: 'column',
};

const WIDTH_BREAKPOINT = 899;

export class ITCGDeck extends React.Component<DeckProp> {
  state: State;

  constructor(prop: DeckProp) {
    super(prop);
    this.state = {
      decks: [],
      build: false,
      initialLoad: false,
      width: window.innerWidth,
    };
  }

  handleResizeWindow = () => this.setState({ width: window.innerWidth });

  async componentDidMount() {
    await this.updateSelf();

    window.addEventListener('resize', this.handleResizeWindow);
  }

  onComponentDestroy() {
    window.removeEventListener('resize', this.handleResizeWindow);
  }

  async updateSelf(obj?: Partial<State>) {
    const resp = await axios('/decks', {
      baseURL: this.props.server,
      timeout: 5000,
      withCredentials: true,
    });

    if (!resp.data) return;

    this.setState({ ...obj, decks: resp.data, initialLoad: true });
  }

  buildDeck(id?: string) {
    this.setState({ build: true, buildDeck: id });
  }

  newDeck() {
    const deckClass = this.state.width > WIDTH_BREAKPOINT ? 'sm-3 col' : 'sm-4 col';
    return (
      <div className={deckClass}>
        <div className="card" key="new" style={CardStyle}>
          <div className="card-body">
            <h3 className="card-title">New Deck</h3>
            <button onClick={() => this.buildDeck()}>Create</button>
          </div>
        </div>
      </div>
    );
  }

  parseDeckLists() {
    const decks = this.state.decks;
    const deckClass = this.state.width > WIDTH_BREAKPOINT ? 'sm-3 col' : 'sm-4 col';

    const parsedList = decks.map((deck) => {
      const formatted = (
        <div className="card" key={deck.id} style={CardStyle}>
          {!deck.modify && <div className="card-header">public</div>}
          <div className="card-body">
            <h3 className="card-title">{deck.name}</h3>
            <h4 className="card-subtitle">{deck.deck_list.character.name}</h4>
            <div className="card-text">{parseDeckList(deck.deck_list)}</div>
            <div className="row flex-edges">
              {deck.modify && (
                <>
                  <button onClick={() => this.buildDeck(deck.id)}>edit</button>
                  <a
                    className="paper-btn btn-warning card-link"
                    href={`/posts/write/${deck.id}`}
                  >
                    share
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      );

      return <div className={deckClass}>{formatted}</div>;
    });

    return (
      <div className="row flex-left" style={{ width: '100%' }}>
        {this.newDeck()}
        {parsedList}
      </div>
    );
  }

  getDeckList() {
    return (
      <>
        <h2>Decks</h2>
        <p style={ParagraphStyle}>
          Public decks are available to everyone and cannot be modified.
        </p>
        {this.parseDeckLists()}
      </>
    );
  }

  render() {
    return (
      <div style={baseStyle}>
        {!this.state.initialLoad && (
          <>
            <h2>Decks</h2>
            <h2 className={'loading'} style={LoadStyle}>
              Loading
            </h2>
          </>
        )}
        {!!this.state.initialLoad && !this.state.build && this.getDeckList()}
        {!!this.state.initialLoad && this.state.build && (
          <ITCGDeckBuilder
            server={this.props.server}
            deckID={this.state.buildDeck}
            update={(obj) => this.updateSelf(obj)}
          />
        )}
      </div>
    );
  }
}

export function parseDeckList(deck: Deck) {
  if (!deck.character) return;
  return (
    <div>
      {deck.deck.map((card) => {
        return (
          <div
            data-tooltip-id="expanded-card"
            data-tooltip-html={renderToStaticMarkup(
              <div>
                <img className="no-border" src={cardImages[card[0].image].top}></img>
                <img className="no-border" src={cardImages[card[0].image].skill}></img>
              </div>
            )}
          >
            {card[1]} {card[0].name}
          </div>
        );
      })}
    </div>
  );
}

export function parseDeckListIntoTable(deck: Deck) {
  if (!deck.character) return;
  return (
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        {deck.deck.map((card) => {
          return (
            <tr
              data-tooltip-id="expanded-card"
              data-tooltip-html={renderToStaticMarkup(
                <div>
                  <img className="no-border" src={cardImages[card[0].image].top}></img>
                  <img className="no-border" src={cardImages[card[0].image].skill}></img>
                </div>
              )}
            >
              <td>{card[1]}</td>
              <td>{card[0].name}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
